// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Tweet from "./Tweet";
import * as Belt_Array from "bs-platform/lib/es6/belt_Array.js";
import * as GlitchedTitle$Es2077 from "./GlitchedTitle.bs.js";

require('./App.css')
;

function tweet(prim) {
  return Tweet.default();
}

function App$Testimonial(Props) {
  var name = Props.name;
  var role = Props.role;
  var image = Props.image;
  var saying = Props.saying;
  return React.createElement("div", {
              className: "py-5"
            }, React.createElement("div", {
                  className: "pb-10 flex items-center flex-col"
                }, React.createElement("img", {
                      className: "h-16 w-16 rounded-full",
                      src: image
                    }), React.createElement("h3", {
                      className: "pt-5 font-bold text-center"
                    }, name, React.createElement("span", {
                          className: "text-gray-700"
                        }, " / " + role))), React.createElement("p", {
                  className: "font-mono text-center px-5 lg:px-64 text-xl font-bold italic text-gray-800"
                }, "“" + (String(saying) + "”")));
}

var Testimonial = {
  make: App$Testimonial
};

function App$BuySection(Props) {
  return React.createElement("div", {
              className: "py-32 lg:p-32 bg-yellow-400 flex justify-center"
            }, React.createElement("div", {
                  className: "bg-white rounded shadow w-11/12 lg:w-1/3"
                }, React.createElement("div", {
                      className: "bg-gray-100 p-10 "
                    }, React.createElement("h1", {
                          className: "font-extrabold text-2xl line-through"
                        }, "R$ 150"), React.createElement("h1", {
                          className: "font-extrabold text-6xl"
                        }, "R$ 77"), React.createElement("h1", {
                          className: "font-extrabold text-2xl text-gray-700"
                        }, "Um Type Na [REDACTED]")), React.createElement("div", {
                      className: "px-10 py-5"
                    }, React.createElement("ul", {
                          className: "py-5 pb-10"
                        }, Belt_Array.mapWithIndex([
                              "Filosofia",
                              "Integração com tooling JS",
                              "Promises te tapearam",
                              "Conceitos básicos da linguagem",
                              "Um outro tipo de TDD",
                              "Forms com ReasonReact",
                              "CSS in Reason",
                              "GraphQL com Reason",
                              "Lib NPM simples com Reason",
                              "O futuro do Reason"
                            ], (function (index, item) {
                                return React.createElement("li", {
                                            key: index.toString(),
                                            className: "py-2 text-lg font-mono"
                                          }, React.createElement("span", undefined, "✨ "), item);
                              }))), React.createElement("div", {
                          className: "w-full flex justify-center"
                        }, React.createElement("a", {
                              className: "bg-black shadow-md text-white hover:bg-gray-900 font-bold text-2xl py-2 px-20 md:px-32 rounded",
                              href: "https://www.mercadopago.com.br/checkout/v1/redirect?preference-id=146683234-4f231ea1-d138-4081-9537-d10782576c38",
                              target: "_blank"
                            }, "Comprar")), React.createElement("div", {
                          className: "border w-full my-5"
                        }), React.createElement("div", {
                          className: "w-full flex justify-center"
                        }, React.createElement("a", {
                              className: "bg-white border shadow-md text-black hover:bg-gray-300 font-bold text-base py-2 px-10 md:px-32 rounded text-center",
                              href: "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=N8XRR7JHQQJB8",
                              target: "_blank"
                            }, "I'm buying from another country")), React.createElement("p", {
                          className: "text-gray-600 text-xs pt-2"
                        }, "Buy checking out with PayPal you'll be contacted via your PayPal account email after payment confirmation. Also send me a message at twitter.com/fakenickels."))));
}

var BuySection = {
  make: App$BuySection
};

function App$oldMake(Props) {
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "h-64 py-64 md:py-0 md:h-screen w-full lg:block bg-hero"
                }, React.createElement("div", {
                      className: "p-0 lg:p-64 sm:p-0"
                    }, React.createElement("div", {
                          className: "bg-black pb-5"
                        }, React.createElement(GlitchedTitle$Es2077.make, {
                              glitchText1: "ReasonML",
                              children: "ES2077"
                            }), React.createElement("h3", {
                              className: "text-center font-mono text-white"
                            }, "UM TYPE NA ", React.createElement("span", {
                                  className: "line-through"
                                }, "GOSTOSA"))))), React.createElement(App$BuySection, { }), React.createElement("div", {
                  className: "py-16"
                }, React.createElement(App$Testimonial, {
                      name: "Guilherme Decampo",
                      role: "CEO da Astrocoders",
                      image: require("./images/testimonial-guilherme.jpg"),
                      saying: "Nos últimos anos, o Gabriel tem liderado a adoção de ReasonML na Astro. Sem dúvidas o time conseguiu adotar e entender os conceitos mais rapidamente com a ajuda e explicações dele."
                    }), React.createElement(App$Testimonial, {
                      name: "Arthur Barroso",
                      role: "Aluno",
                      image: "https://avatars2.githubusercontent.com/u/48794198?s=400",
                      saying: "Pouco antes de começar o curso do Gabriel eu havia dado inicio aos meus estudos em Reason. Meu principal objetivo com isso era poder me aprofundar em uma linguagem diferente da utilizada no trabalho e, assim, desenvolver outras linhas de abordagem para os problemas. Posso dizer que se hoje sou um programador melhor devo em muito ao Reason e, principalmente ao Gabriel com seu curso e todo o suporte dado."
                    }), React.createElement(App$Testimonial, {
                      name: "Marcos Oliveira",
                      role: "Designer & Dev lindo na Lukin Co",
                      image: "https://avatars0.githubusercontent.com/u/20327229?s=400",
                      saying: "Mesmo já conhecendo ReasonML e o utilizando em diversos projetos, fiz questão de comprar o curso pois sei que o conteúdo produzido pelo Gabriel é de altíssima qualidade. Certamente, este curso é umas das melhores formas de se começar com ReasonML. Gabriel não só conhece a tecnologia, como também a utiliza em diversos produtos dele, não tenho dúvidas de que o curso vale super a pena para desenvolvedores de diversos níveis e linguagens."
                    }), React.createElement(App$Testimonial, {
                      name: "Celso Bonutti",
                      role: "Aluno & Mantainer da @fp_ssa",
                      image: "https://avatars0.githubusercontent.com/u/12688694?s=400",
                      saying: "se esse curso já existisse quando eu comecei a aprender reason, eu n teria gasto 2 semanas tentando descobrir como fazer setup de um projeto APOKDOPKWDPOKAWPORK"
                    }), React.createElement(App$Testimonial, {
                      name: "Guilherme de Andrade",
                      role: "Aluno",
                      image: "https://github.com/guilhermedeandrade.png",
                      saying: "ES2077 is ReasonML é curso muito bem pensado e produzido. Atráves dele, o Gabriel passa sua experiência com ReasonML em produção de uma forma clara e objetiva. Acredito que este curso oferece toda a base necessária para quem deseja desenvolver utilizando ReasonML."
                    })), React.createElement(App$BuySection, { }), React.createElement("div", {
                  className: "bg-yellow-400 lg:px-64 lg:py-32 sm:px-32 sm:py-10"
                }, React.createElement("div", {
                      className: "pb-10 flex justify-center"
                    }, React.createElement("img", {
                          className: "h-32 w-32 rounded-full",
                          src: require("./images/fakenickels.jpg")
                        })), React.createElement("p", {
                      className: "font-mono p-10 md:p-0"
                    }, "Olá 👋 eu sou Gabriel R. Abreu! CTO da Astrocoders, entusiasta de código aberto, mantedor do ReasonApolloHooks e criador do ReForm."), Belt_Array.mapWithIndex([
                      "Nos últimos anos, trabalhei diretamente com projetos na que enviaram dezenas de milhares de linhas de código de ReasonML para produção. Não foi um caminho fácil mas uma escolha certeira:\nAplicações feitas usando ReasonML são praticamente inquebráveis.",
                      "Eu gostei tanto da linguagem que acabei virando o \"louco do Reason\". Na Astro ajudei de perto várias pessoas do meu time a aprender a linguagem. Dei algumas talks, contribui com a comunidade e organizei alguns eventos sobre.",
                      "Mas mesmo assim percebo que ainda não existe muito material em português sobre programação funcional vindo de alguém com experiência em produção no assunto.",
                      "Por isso trago esse mini-curso como o começo de uma jornada para disponibilizar esse conhecimento de forma acessível."
                    ], (function (index, saying) {
                        return React.createElement("p", {
                                    key: index.toString(),
                                    className: "font-mono p-10 md:p-0 md:pt-10"
                                  }, saying);
                      }))), React.createElement("div", {
                  className: "flex flex-col items-center bg-gray-100 py-10 sm:px-10"
                }, React.createElement("h3", {
                      className: "text-center font-semibold text-4xl font-mono"
                    }, "Lançamento no Twitter"), Tweet.default()), React.createElement("div", {
                  className: "py-16 px-10"
                }, React.createElement("h1", {
                      className: "text-6xl"
                    }, "Perguntas frequentes"), React.createElement("div", {
                      className: "pt-10 divide-y divide-gray-200"
                    }, Belt_Array.mapWithIndex([
                          /* tuple */[
                            "Preciso desse curso pra aprender Reason?",
                            "NÃO! Você pode aprender nas documentações oficiais e da comunidade. Eu apenas te guio pelo caminho mais rapidamente."
                          ],
                          /* tuple */[
                            "O curso vai ser atualizado pra REScript?",
                            "Sim. Ao longo de 2021 o curso será atualizado para abarcar tanto Reason e REScript. Todos que já compraram o curso terão acesso."
                          ],
                          /* tuple */[
                            "Por quanto tempo terei acesso ao curso?",
                            "Depois da compra, o acesso ao curso é vitalício."
                          ],
                          /* tuple */[
                            "Quando as novas aulas são liberadas?",
                            "Todas as aulas já estão disponíveis."
                          ],
                          /* tuple */[
                            "Preciso saber programação funcional antes?",
                            "Ter alguma noção ajudaria, mas não é preciso. Você vai poder tirar dúvidas comigo a qualquer hora durante o curso."
                          ],
                          /* tuple */[
                            "Posso ser estornado?",
                            "Sim. A qualquer momento em até no máximo 3 semanas. Fale comigo no https://t.me/fakenickels"
                          ],
                          /* tuple */[
                            "Posso ter um certificado desse curso?",
                            "Se você precisa de um certificado fale comigo no https://t.me/fakenickels"
                          ]
                        ], (function (index, param) {
                            return React.createElement("div", {
                                        key: String(index),
                                        className: "py-10 md:grid md:grid-cols-12"
                                      }, React.createElement("h3", {
                                            className: "text-lg font-semibold md:col-span-5"
                                          }, param[0]), React.createElement("p", {
                                            className: "text-lg font-semibold text-gray-800 md:col-span-7 pl-0 md:pl-10"
                                          }, param[1]));
                          })))), React.createElement("div", {
                  className: "p-10 flex flex-col bg-gray-900 items-center"
                }, React.createElement("div", {
                      className: "flex flex-col lg:flex-row lg:justify-around items-center w-1/2"
                    }, Belt_Array.map([
                          /* tuple */[
                            "Twitter",
                            "https://twitter.com/fakenickels"
                          ],
                          /* tuple */[
                            "GitHub",
                            "https://github.com/fakenickels"
                          ],
                          /* tuple */[
                            "Blog",
                            "https://medium.com/@fakenickels"
                          ]
                        ], (function (param) {
                            var label = param[0];
                            return React.createElement("a", {
                                        key: label,
                                        className: "text-gray-400 hover:text-gray-300 px-2 font-bold pt-5 sm:pt-0",
                                        href: param[1],
                                        target: "_blank"
                                      }, label);
                          }))), React.createElement("p", {
                      className: "pt-10 text-center text-gray-600 font-semibold font-mono"
                    }, "fakenickels © 2077")));
}

function App(Props) {
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "h-64 py-64 md:py-0 md:h-screen w-full lg:block bg-hero"
                }, React.createElement("div", {
                      className: "p-0 lg:p-64 sm:p-0"
                    }, React.createElement("div", {
                          className: "bg-black pb-5"
                        }, React.createElement(GlitchedTitle$Es2077.make, {
                              glitchText1: "ReasonML",
                              children: "ReScript"
                            }), React.createElement("h3", {
                              className: "text-center font-mono text-white"
                            }, "Aguarde para o novo ", React.createElement("span", {
                                  className: "line-through"
                                }, "ReasonML"))))), React.createElement("div", {
                  className: "py-16 px-10"
                }, React.createElement("h1", {
                      className: "text-6xl"
                    }, "Perguntas frequentes"), React.createElement("div", {
                      className: "pt-10 divide-y divide-gray-200"
                    }, Belt_Array.mapWithIndex([
                          /* tuple */[
                            "Aguarde o que?",
                            "Como prometido, ao longo de 2021 o curso será atualizado para abarcar tanto Reason e REScript. Para evitar confusão estou temporariamente limitando a compra do curso para que novos alunos já vejam a nova versão. Alunos já inscritos continuam tendo acesso normal ao conteúdo."
                          ],
                          /* tuple */[
                            "Preciso desse curso pra aprender REScript?",
                            "NÃO! Você pode aprender nas documentações oficiais e da comunidade. Eu apenas te guio pelo caminho mais rapidamente."
                          ],
                          /* tuple */[
                            "Por quanto tempo terei acesso ao curso?",
                            "Depois da compra, o acesso ao curso é vitalício."
                          ],
                          /* tuple */[
                            "Preciso saber programação funcional antes?",
                            "Ter alguma noção ajudaria, mas não é preciso. Você vai poder tirar dúvidas comigo a qualquer hora durante o curso."
                          ],
                          /* tuple */[
                            "Posso ser estornado?",
                            "Sim. A qualquer momento em até no máximo 3 semanas. Fale comigo no https://t.me/fakenickels"
                          ],
                          /* tuple */[
                            "Posso ter um certificado desse curso?",
                            "Se você precisa de um certificado fale comigo no https://t.me/fakenickels"
                          ]
                        ], (function (index, param) {
                            return React.createElement("div", {
                                        key: String(index),
                                        className: "py-10 md:grid md:grid-cols-12"
                                      }, React.createElement("h3", {
                                            className: "text-lg font-semibold md:col-span-5"
                                          }, param[0]), React.createElement("p", {
                                            className: "text-lg font-semibold text-gray-800 md:col-span-7 pl-0 md:pl-10"
                                          }, param[1]));
                          })))), React.createElement("div", {
                  className: "p-10 flex flex-col bg-gray-900 items-center"
                }, React.createElement("div", {
                      className: "flex flex-col lg:flex-row lg:justify-around items-center w-1/2"
                    }, Belt_Array.map([
                          /* tuple */[
                            "Twitter",
                            "https://twitter.com/fakenickels"
                          ],
                          /* tuple */[
                            "GitHub",
                            "https://github.com/fakenickels"
                          ],
                          /* tuple */[
                            "Blog",
                            "https://medium.com/@fakenickels"
                          ]
                        ], (function (param) {
                            var label = param[0];
                            return React.createElement("a", {
                                        key: label,
                                        className: "text-gray-400 hover:text-gray-300 px-2 font-bold pt-5 sm:pt-0",
                                        href: param[1],
                                        target: "_blank"
                                      }, label);
                          }))), React.createElement("p", {
                      className: "pt-10 text-center text-gray-600 font-semibold font-mono"
                    }, "fakenickels © 2077")));
}

var oldMake = App$oldMake;

var make = App;

export {
  tweet ,
  Testimonial ,
  BuySection ,
  oldMake ,
  make ,
  
}
/*  Not a pure module */
